import { HomeData } from '@practium/features/home';

export const adminHomeMockData: HomeData = {
	user: {
		name: 'Admin Practium',
		type: 'Master',
		plan: 'System',
	},

	carousel: [
		{
			id: '1',
			title: 'Novidades do sistema: Atualizações e melhorias recentes',
			buttonText: 'Ver changelog',
			buttonLink: '/admin/changelog',
			imageUrl: '/images/carousel-slide-1.jpg',
		},
		{
			id: '2',
			title: 'Monitoramento de saúde do sistema e métricas de performance',
			buttonText: 'Ver status',
			buttonLink: '/logs',
			imageUrl: '/images/carousel-slide-2.jpg',
		},
		{
			id: '3',
			title: 'Gestão de usuários e permissões: Guia completo',
			buttonText: 'Saber Mais',
			buttonLink: '/sistema',
			imageUrl: '/images/carousel-slide-3.jpg',
		},
	],

	actionCards: [
		{
			id: 'flora-ai',
			title: 'Flora AI',
			subtitle: 'Suporte administrativo e gerenciamento de créditos da plataforma',
			buttonText: 'Acessar',
			buttonLink: '/flora-ai',
			variant: 'flora',
		},
		{
			id: 'usuarios',
			title: 'Usuários',
			subtitle: 'Gerencie todos os usuários, planos e hierarquias do sistema',
			buttonText: 'Gerenciar',
			buttonLink: '/usuarios',
			variant: 'applications',
		},
		{
			id: 'dashboard',
			title: 'Dashboard',
			subtitle: 'Métricas do sistema, analytics e relatórios administrativos',
			buttonText: 'Ver agora',
			buttonLink: '/dashboard',
			variant: 'dashboard',
		},
	],

	calendar: {
		currentMonth: 'Maio',
		currentYear: 2026,
		events: [
			{
				id: '1',
				title: 'Manutenção Programada',
				description: 'Atualização do banco de dados - 02:00 às 04:00',
				date: '2026-05-18',
				type: 'manutencao',
				icon: '🔧',
				color: 'var(--primary)',
			},
			{
				id: '2',
				title: 'Release v2.5.0',
				description: 'Deploy de novas funcionalidades',
				date: '2026-05-25',
				type: 'release',
				icon: '🚀',
				color: 'var(--primary)',
			},
			{
				id: '3',
				title: 'Backup Completo do Sistema',
				description: 'Backup mensal automático',
				date: '2026-06-01',
				type: 'backup',
				icon: '💾',
				color: 'var(--primary)',
			},
			{
				id: '4',
				title: 'Reunião com Equipe de Desenvolvimento',
				description: 'Sprint planning e retrospectiva',
				date: '2026-06-05',
				type: 'reuniao',
				icon: '👥',
				color: 'var(--primary)',
			},
		],
		selectedPeriod: {
			start: '2026-05-18',
			end: '2026-06-05',
		},
	},

	history: [
		{
			id: '1',
			action: 'Novo plano de assinatura criado',
			department: 'Planos',
			date: '12/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-12T10:00:00Z',
		},
		{
			id: '2',
			action: 'Política de privacidade atualizada',
			department: 'LGPD',
			date: '11/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-11T14:00:00Z',
		},
		{
			id: '3',
			action: 'Logs de segurança analisados',
			department: 'Segurança',
			date: '10/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-10T09:00:00Z',
		},
		{
			id: '4',
			action: 'Relatório de uso da plataforma gerado',
			department: 'Analytics',
			date: '09/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-09T16:30:00Z',
		},
	],

	planInfo: {
		name: 'System',
		expirationDate: '∞',
		upgradeMessage: 'Acesso total ao sistema administrativo do Practium',
	},
};
